export const workKeys = {
    all: ['work'] as const,
    customer: (customerId: string, includeClosedWork: boolean) =>
        [...workKeys.all, 'customer', customerId, {includeClosedWork}] as const,
    pickupCandidates: (projectId: string) =>
        [...workKeys.all, 'pickup-candidates', projectId] as const,
    pickupUnits: (projectId: string, jobId: string) =>
        [...workKeys.all, 'pickup-units', projectId, jobId] as const,
    pickupsToConfirm: (yardId: string | null) =>
        [...workKeys.all, 'pickups-to-confirm', yardId ?? 'all'] as const,
}
